import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconCompaniesNoPayroll: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = 'currentColor',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 20.25H21.75V11C21.75 9.252 20.748 8.25 19 8.25H18.75V6C18.75 3.582 17.418 2.25 15 2.25H9C6.582 2.25 5.25 3.582 5.25 6V8.25H5C3.252 8.25 2.25 9.252 2.25 11V20.25H2C1.586 20.25 1.25 20.586 1.25 21C1.25 21.414 1.586 21.75 2 21.75H22C22.414 21.75 22.75 21.414 22.75 21C22.75 20.586 22.414 20.25 22 20.25ZM6.75 6C6.75 4.423 7.423 3.75 9 3.75H15C16.577 3.75 17.25 4.423 17.25 6V20.25H14.75V18C14.75 16.483 13.517 15.25 12 15.25C10.483 15.25 9.25 16.483 9.25 18V20.25H6.75V6ZM13.25 20.25H10.75V18C10.75 17.311 11.311 16.75 12 16.75C12.689 16.75 13.25 17.311 13.25 18V20.25ZM3.75 11C3.75 10.089 4.089 9.75 5 9.75H5.25V20.25H3.75V11ZM18.75 20.25V9.75H19C19.911 9.75 20.25 10.089 20.25 11V20.25H18.75ZM8.75 7C8.75 6.586 9.086 6.25 9.5 6.25H10.5C10.914 6.25 11.25 6.586 11.25 7C11.25 7.414 10.914 7.75 10.5 7.75H9.5C9.086 7.75 8.75 7.414 8.75 7ZM12.75 7C12.75 6.586 13.086 6.25 13.5 6.25H14.5C14.914 6.25 15.25 6.586 15.25 7C15.25 7.414 14.914 7.75 14.5 7.75H13.5C13.086 7.75 12.75 7.414 12.75 7ZM8.75 10C8.75 9.586 9.086 9.25 9.5 9.25H10.5C10.914 9.25 11.25 9.586 11.25 10C11.25 10.414 10.914 10.75 10.5 10.75H9.5C9.086 10.75 8.75 10.414 8.75 10ZM12.75 10C12.75 9.586 13.086 9.25 13.5 9.25H14.5C14.914 9.25 15.25 9.586 15.25 10C15.25 10.414 14.914 10.75 14.5 10.75H13.5C13.086 10.75 12.75 10.414 12.75 10ZM8.75 13C8.75 12.586 9.086 12.25 9.5 12.25H10.5C10.914 12.25 11.25 12.586 11.25 13C11.25 13.414 10.914 13.75 10.5 13.75H9.5C9.086 13.75 8.75 13.414 8.75 13ZM12.75 13C12.75 12.586 13.086 12.25 13.5 12.25H14.5C14.914 12.25 15.25 12.586 15.25 13C15.25 13.414 14.914 13.75 14.5 13.75H13.5C13.086 13.75 12.75 13.414 12.75 13Z"
      fill={color}
    />
  </svg>
);

export default IconCompaniesNoPayroll;
